(function () {
  function setup(section) {
    if (!('IntersectionObserver' in window)) return;
    if (section.classList.contains('cat-anim')) return; // avoid double init
    section.classList.add('cat-anim');

    var targets = [];
    var heading = section.querySelector('.categories-custom__heading');
    if (heading) targets.push(heading);

    section.querySelectorAll('.category-card').forEach(function (c) {
      targets.push(c);
    });

    var moreBtn = section.querySelector('.categories-custom__more');
    if (moreBtn) targets.push(moreBtn);

    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initAll() {
    document.querySelectorAll('.categories-custom').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.categories-custom');
    if (section) setup(section);
  });
})();
